const antd = window.antd;

export const Base = antd.Base;
export const message = antd.message;
export const notification = antd.notification;
export const Affix = antd.Affix;
export const Anchor = antd.Anchor;
export const AutoComplete = antd.AutoComplete;
export const Alert = antd.Alert;
export const Avatar = antd.Avatar;
export const BackTop = antd.BackTop;
export const Badge = antd.Badge;
export const Breadcrumb = antd.Breadcrumb;
export const Button = antd.Button;
export const Calendar = antd.Calendar;
export const Card = antd.Card;
export const Collapse = antd.Collapse;
export const Carousel = antd.Carousel;
export const Cascader = antd.Cascader;
export const Checkbox = antd.Checkbox;
export const Col = antd.Col;
export const DatePicker = antd.DatePicker;
export const Divider = antd.Divider;
export const Dropdown = antd.Dropdown;
export const Form = antd.Form;
export const FormModel = antd.FormModel;
export const Icon = antd.Icon;
export const Input = antd.Input;
export const InputNumber = antd.InputNumber;
export const Layout = antd.Layout;
export const List = antd.List;
export const LocaleProvider = antd.LocaleProvider;
export const Menu = antd.Menu;
export const Mentions = antd.Mentions;
export const Modal = antd.Modal;
export const Pagination = antd.Pagination;
export const Popconfirm = antd.Popconfirm;
export const Popover = antd.Popover;
export const Progress = antd.Progress;
export const Radio = antd.Radio;
export const Rate = antd.Rate;
export const Row = antd.Row;
export const Select = antd.Select;
export const Slider = antd.Slider;
export const Spin = antd.Spin;
export const Statistic = antd.Statistic;
export const Steps = antd.Steps;
export const Switch = antd.Switch;
export const Table = antd.Table;
export const Transfer = antd.Transfer;
export const Tree = antd.Tree;
export const TreeSelect = antd.TreeSelect;
export const Tabs = antd.Tabs;
export const Tag = antd.Tag;
export const TimePicker = antd.TimePicker;
export const Timeline = antd.Timeline;
export const Tooltip = antd.Tooltip;
export const Upload = antd.Upload;
export const Drawer = antd.Drawer;
export const Skeleton = antd.Skeleton;
export const Comment = antd.Comment;
export const ConfigProvider = antd.ConfigProvider;
export const Empty = antd.Empty;
export const Result = antd.Result;
export const Descriptions = antd.Descriptions;
export const PageHeader = antd.PageHeader;
